module.exports = __webpack_public_path__ + "static/media/icing-blue.160e847a.png";